import React from 'react';
import { Progress, Tooltip } from 'antd';

const EQUITY_STROKES = ['#13c2c2','#08979c', '#006d75', '#00474f', '#00474f'];
const FIXED_STROKES = ['#9e1068', '#9e1068', '#780650', '#520339', '#520339'];

const TargetAllocations = ({ equity, fixed }) => {
  // Error handling for sum not equal to 100
  if (equity + fixed !== 100) {
    console.error('The sum of equity and fixed does not equal 100%');
    return null;
  }

  let strokes = {}
  if (equity===100){
    Object.assign(strokes, {
      '0%': EQUITY_STROKES[0],
      '100%': EQUITY_STROKES[3]
    })
  }
  else if (fixed===100){
    Object.assign(strokes, {
      '0%': FIXED_STROKES[0],
      '100%': FIXED_STROKES[3]
    })
  }
  else {
    Object.assign(strokes, {
      '0%': EQUITY_STROKES[3],
      [`${equity}%`]: EQUITY_STROKES[0],
      [`${equity+1}%`]: FIXED_STROKES[0],
      '100%': FIXED_STROKES[3]

    })
  }

  return (
    <div style={{ width: '100%' }}>
      <Tooltip title={`Equity: ${equity}%, Fixed: ${fixed}%`}>
        <Progress
          type={'dashboard'}
          percent={100}
          strokeColor={strokes}
          style={{ marginBottom: '4px' }}
          format={(percent) => `${equity} / ${fixed}`}
          size={'small'}
          status={'normal'}
        />
      </Tooltip>
    </div>
  );
};

export default TargetAllocations;
